var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactUs"},[_c('p',{on:{"click":_vm.back}},[_c('i',{staticClass:"iconfont icon-fanhuidingbu",staticStyle:{"color":"#585858","font-size":"27px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }